import { SelectionChangedEvent } from "ag-grid-community";
import { CompanyChargeSuppleTermsEntity } from "domain/entity/Company/CompanyChargeSuppleTermsEntity";
import { AclType } from "presentation/constant/ANAInfo/NbisivPermission";
import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { INITIAL_CHARGE_SUPPLE_TERMS_COL_DEF, INITIAL_CHARGE_SUPPLE_TERMS_COL_DEF_AQCT, transferRowData } from "presentation/constant/Company/ChargeSuppleTermsColumnDefinition";
import { CompanyConstant } from "presentation/constant/Company/CompanyConstant";
import { useChargeSuppleTermsVM } from "presentation/hook/Company/useChargeSuppleTermsVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { isPermissionExist } from "presentation/utils/permissionUtils";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { HPHButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const ChargeSuppleTermsTablePanel: React.FC = () => {
    const [companyDtlState] = useCompanyDetailTracked();
    const [anainfoState] = useANAInfoTracked();
    const chargeSuppleTermsVM = useChargeSuppleTermsVM();
    const messageBarVM = useMessageBarVM();
    const { operatingUnit, allowCreate, allowDelete, allowUpdate } = anainfoState;
    const [isLoading, setIsLoading] = useState(false);
    const { isAdd, isEditable, isEditCompDtlInfo, isShowFsp, isShowEmptyPool, isShowSuppleTerms, isShowCustAssign,
        isShowCustInfo, isShowFactor, isShowFspBulkEdit } = companyDtlState.viewState;
    const COMPANY_DTL_CONST = CompanyConstant.Detail;
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const { selectedDatas } = companyDtlState.chargeSuppleTermsState

    //const isReadReject = isPermissionExist(Permission.COMPANY_CHARGE_SUPPLE_TERMS_REJECT, AclType.READ, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    const isUpdateReject = isPermissionExist(Permission.COMPANY_CHARGE_SUPPLE_TERMS_REJECT, AclType.UPDATE, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    //const isReadApprove = isPermissionExist(Permission.COMPANY_CHARGE_SUPPLE_TERMS_APPROVE, AclType.READ, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    const isUpdateApprove = isPermissionExist(Permission.COMPANY_CHARGE_SUPPLE_TERMS_APPROVE, AclType.UPDATE, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);

    let gridRef: any = useRef();

    const memoTableBtns = useMemo(() => {
        const tableBtns = [];

        tableBtns.push({
            id: 'onRefreshButton',
            icon: 'Icon-reload',
            title: 'Refresh'
        })

        /*if (isEditCompDtlInfo) {
            if (!(isAdd || isEditable)) {*/
        if (allowDelete) {
            tableBtns.push({
                id: 'onDeleteButton',
                icon: 'Icon-trash',
                title: 'Delete',
                disable: !(isEditCompDtlInfo/* && !(isAdd || isEditable)*/)
            })
        }

        if (allowCreate) {
            tableBtns.push({
                id: 'onAddButton',
                icon: 'Icon-add',
                title: 'Add',
                disable: !(isEditCompDtlInfo/* && !(isAdd || isEditable)*/)
            })
        }
        /*    }
        }*/

        return tableBtns
    }, [isEditCompDtlInfo, allowDelete, allowCreate])

    const handleAddClick = useCallback(() => {
        chargeSuppleTermsVM.onAdd();
    }, [chargeSuppleTermsVM])

    const handleDelete = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to delete.");
            return;
        }

        const isAllowDelete = !(selectedDatas?.find(selectedData => (selectedData.status === "FINALIZED" || selectedData.status === "PROPOSED")));
        if (!isAllowDelete) {
            messageBarVM.showError("Record status is PROPOSED/FINALIZED, cannot delete.");
            return;
        }

        chargeSuppleTermsVM.handleDelete();
    }, [chargeSuppleTermsVM, messageBarVM, selectedDatas]);

    const handleRefresh = useCallback(() => {
        setIsLoading(true);
        companyDtlState.companyId && chargeSuppleTermsVM.initialChgSuppleTermsTableData(companyDtlState.companyId).then(() => {
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false)
        })
    }, [chargeSuppleTermsVM, companyDtlState.companyId]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent, delay: number = 250) => {
        if (isAdd) return;

        const selectedRows = e.api.getSelectedRows();
        chargeSuppleTermsVM.onSelectedCompSuppleTerms(selectedRows);
    }, [chargeSuppleTermsVM, isAdd])

    const handleRowDoubleClick = useCallback((entity: CompanyChargeSuppleTermsEntity) => {
        chargeSuppleTermsVM.onSuppleTermsRowDoubleClick(entity);
    }, [chargeSuppleTermsVM])

    const isDisableSubmit = useCallback(() => {
        if (selectedDatas.length < 1
            || selectedDatas?.find(selectedData => (selectedData.status === "FINALIZED"))) {
            return true;
        }

        return false;
    }, [selectedDatas]);

    const isDisableReject = useCallback(() => {
        if (selectedDatas.length < 1
            || selectedDatas?.find(selectedData => (
                !((selectedData.status === "FINALIZED" || selectedData.status === "PROPOSED") && selectedData.confirmedDate === null))
            )) {
            return true;
        }

        return false;
    }, [selectedDatas]);

    const isDisableApprove = useCallback(() => {
        if (selectedDatas.length < 1
            || selectedDatas?.find(selectedData => (
                !((selectedData.status === "FINALIZED" || selectedData.status === "PROPOSED") && selectedData.confirmedDate === null))
            )) {
            return true;
        }

        return false;
    }, [selectedDatas]);

    const handleSubmit = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to submit.");
            return;
        }

        setIsLoading(true);
        chargeSuppleTermsVM.onSubmit(selectedDatas).then(() => {
            companyDtlState.companyId && chargeSuppleTermsVM.initialChgSuppleTermsTableData(companyDtlState.companyId).then(() => {
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false)
            })
        }).catch((error) => {
            setIsLoading(false)
            messageBarVM.showError(error.message)
        })

    }, [companyDtlState.companyId, chargeSuppleTermsVM, messageBarVM, selectedDatas]);

    const handleReject = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to reject.");
            return;
        }

        chargeSuppleTermsVM.handleReject();
    }, [chargeSuppleTermsVM, messageBarVM, selectedDatas]);

    const handleApprove = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to approve.");
            return;
        }

        setIsLoading(true);
        chargeSuppleTermsVM.onApprove(selectedDatas).then(() => {
            companyDtlState.companyId && chargeSuppleTermsVM.initialChgSuppleTermsTableData(companyDtlState.companyId).then(() => {
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false)
            })
        }).catch((error) => {
            setIsLoading(false)
            messageBarVM.showError(error.message)
        })

    }, [companyDtlState.companyId, chargeSuppleTermsVM, messageBarVM, selectedDatas]);

    const isRowSelectable = useCallback((params: any) => {
        if ((isShowSuppleTerms && (isEditable || isAdd))
            || isShowFsp || isShowEmptyPool || isShowCustAssign || isShowCustInfo || isShowFactor || isShowFspBulkEdit) {
            return false;
        } else {
            return true;
        }
    }, [isAdd, isEditable, isShowCustAssign, isShowCustInfo, isShowEmptyPool, isShowFactor, isShowFsp, isShowSuppleTerms, isShowFspBulkEdit]);

    const memoTableTitle = useMemo(() =>
        <Sidebarheader style={{ width: "100%", display: "flex", alignItems: "center" }}>
            <HeaderTitle>{COMPANY_DTL_CONST.CHARGE_SUPPLE_TERMS.CHG_SUPPLE_TERMS}</HeaderTitle>
            <StyledAction className="tm-animated-wrapper">
                {
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        {allowUpdate && <HPHButton label={'Submit'} size={'Small'} disabled={isDisableSubmit() || !isEditCompDtlInfo} theme={'Secondary'} onClick={handleSubmit} />}
                        {(isUpdateReject) && <HPHButton label={'Reject'} size={'Small'} disabled={isDisableReject()} theme={'Secondary'} onClick={handleReject} />}
                        {(isUpdateApprove) && <HPHButton label={'Approve'} size={'Small'} disabled={isDisableApprove()} theme={'Primary'} onClick={handleApprove} />}
                    </div>
                }
            </StyledAction>
        </Sidebarheader>
        , [COMPANY_DTL_CONST.CHARGE_SUPPLE_TERMS.CHG_SUPPLE_TERMS, handleApprove, handleReject, handleSubmit, isDisableApprove, isDisableReject, isDisableSubmit, isEditCompDtlInfo, isUpdateApprove, isUpdateReject, allowUpdate])

    const memoChargeSuppleTermsTable = useMemo(() => {
        return (
            <div style={{ marginTop: "50px" }}>
                <NbisTable
                    id='charge-supple-terms-table'
                    isNewColumnSetting={true}
                    columns={((operatingUnit === "SAPT" || operatingUnit === "KICT") ? INITIAL_CHARGE_SUPPLE_TERMS_COL_DEF : INITIAL_CHARGE_SUPPLE_TERMS_COL_DEF_AQCT)?.slice()}
                    data={transferRowData(companyDtlState.compChargeSuppleTerms) ?? []}
                    headerActionButtons={memoTableBtns}
                    showPaginator={false}
                    editable={false}
                    showHeaderIcons={true}
                    showAddIcon={false}
                    showDeleteButton={false}
                    showReloadIcon={false}
                    isScrollHighlighted={true}
                    isRowHighligted={true}
                    selectionMode={false}
                    rowSelection={"multiple"}
                    handleSelectionChanged={(e: any) => handleSelectionChange(e, 400)}
                    onRowDoubleClick={(e: any, row: CompanyChargeSuppleTermsEntity) => handleRowDoubleClick(row)}
                    onAddButton={handleAddClick}
                    onRefreshButton={handleRefresh}
                    onDeleteButton={handleDelete}
                    gridHeight="customHeight"
                    customHeight="calc(100vh - 700px)"
                    ref={gridRef}
                    headerLabel={memoTableTitle}
                    handleRowSelectable={isRowSelectable}
                    showPivotMode={false}
                />
            </div>
        );
    }, [companyDtlState.compChargeSuppleTerms, memoTableBtns, handleAddClick, handleRefresh, handleDelete, memoTableTitle, isRowSelectable, handleSelectionChange, handleRowDoubleClick, operatingUnit])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            if (isShowFsp || isShowEmptyPool || isShowCustAssign || isShowCustInfo || isShowFactor || isAdd || isShowFspBulkEdit) {
                gridRef.current?.gridRef.current.api?.deselectAll();
            }
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isAdd, isEditable, isShowSuppleTerms, isShowCustAssign, isShowCustInfo, isShowEmptyPool, isShowFactor, isShowFsp, isShowFspBulkEdit])

    return <><TableWrapper>{memoChargeSuppleTermsTable}</TableWrapper>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />} </>;
}

export default memo(ChargeSuppleTermsTablePanel);
